import {ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import * as L from 'leaflet';
import {LatLng, latLng, Map, Marker, MarkerOptions} from 'leaflet';
import {MobileViewService} from 'gelios-ng-admin-components';
import {MapService} from '../../../app/shared/map.service';
import {MapTileLayerSettingsService} from '../../../app/map-settings/map-services/map-tile-layer-settings.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-gelios-map-unit-coordinates-field',
  templateUrl: './gelios-map-unit-coordinates-field.component.html',
  providers: [
    {
      provide: MapTileLayerSettingsService,
      useClass: MapTileLayerSettingsService
    },
  ]
})
export class GeliosMapUnitCoordinatesFieldComponent extends GeliosFieldBaseComponent implements OnInit, OnDestroy {
  @HostBinding('class.map-container') mapContainer = true;
  boundsSubscription: Subscription | null = null;
  map: Map;
  currentMarker: Marker = null;
  leafletOptions = {
    layers: [this.mapTileLayerSettingsService.currentTileLayer.getValue()],
    zoom: 13,
    center: latLng(53.9, 27.55),
    zoomControl: false,
    attributionControl: false
  };
  leafletZoomOptions = {
    animate: true
  };

  constructor(
    protected translate: TranslateService,
    public mobileView: MobileViewService,
    protected mapService: MapService,
    protected mapTileLayerSettingsService: MapTileLayerSettingsService,
    protected changeDetector: ChangeDetectorRef,
  ) {
    super(translate);
  }

  onMapReady(lmap: L.Map) {
    this.map = lmap;
    if (this.map) {
      this.map.on('click', this.onClick, this);
      this.map.invalidateSize();
      const fieldValue = this.formGroup.controls[this.fieldName].value;
      if (fieldValue) {
        const latLon = (fieldValue as string).split(', ');
        const lat = parseFloat(latLon[0]);
        const lon = parseFloat(latLon[1]);
        this.setMarker(lat, lon);
        this.map.setView([lat, lon], 18);
      }
    }
  }

  onExternalValueChange(value) {
    if (!value) {
      if (this.currentMarker) {
        this.map.removeLayer(this.currentMarker);
        this.currentMarker = null;
      }
      return;
    }
    const newLatLon = (value as string).split(', ');
    const newLat = this.roundCoordinates(parseFloat(newLatLon[0]));
    const newLon = this.roundCoordinates(parseFloat(newLatLon[1]));
    if (!this.currentMarker) {
      this.setMarker(newLat, newLon);
      return;
    }
    const currentLat = this.currentMarker.getLatLng().lat;
    const currentLon = this.currentMarker.getLatLng().lng;
    if (Math.abs(currentLat - newLat) > 1e-7 || Math.abs(currentLon - newLon) > 1e-7) {
      this.setMarker(newLat, newLon);
      this.changeDetector.detectChanges();
    }
  }

  onValueChange(value) {
    this.valueChange.emit({
      fieldName: this.fieldName,
      value: value,
    });
  }

  onClick(event) {
    this.setMarker(this.roundCoordinates(event.latlng.lat), this.roundCoordinates(event.latlng.lng));
    this.changeDetector.detectChanges();
  }

  roundCoordinates(coord) {
    return (Math.round(coord * 1e6) / 1e6);
  }

  setMarker(lat, lon) {
    if (this.currentMarker) {
      this.map.removeLayer(this.currentMarker);
    }
    const markerOptions: MarkerOptions = {
      draggable: true,
    };
    if (this.reflexiveField.mapLatLngFieldConfig && this.reflexiveField.mapLatLngFieldConfig) {
      markerOptions.icon = this.reflexiveField.mapLatLngFieldConfig.icon();
    }
    this.currentMarker = new Marker(new LatLng(lat, lon), markerOptions);
    this.onValueChange(this.roundCoordinates(lat) + ', ' + lon);
    this.currentMarker.on(
      'dragend',
      (dragendEvent: any) => {
        this.onValueChange(
          this.roundCoordinates(dragendEvent.target.getLatLng().lat)
          + ', ' + this.roundCoordinates(dragendEvent.target.getLatLng().lng));
      });
    this.currentMarker.addTo(this.map);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.reflexiveField.mapLatLngFieldConfig.boundsSubject) {
      this.boundsSubscription = this.reflexiveField.mapLatLngFieldConfig.boundsSubject.subscribe(
        bounds => {
          if (this.map) {
            this.map.fitBounds(bounds);
          }
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.boundsSubscription) {
      this.boundsSubscription.unsubscribe();
    }
  }
}

